import BaseView from './BaseView';
import barba from '@barba/core';
import VideoPlayer from "../../modules/VideoPlayer";

let view = null;

class Project extends BaseView {
	constructor(container) {
		super(container);

		this.closeButton = this.container.querySelector('[data-close-project]');
		this.closeButtonText = this.closeButton.querySelector('.screen-reader-text');
		if(barba.history.previous&&barba.history.previous.ns!='single-project') {
			this.closeButton.setAttribute('href', barba.history.previous.url);
			this.closeButtonText.innerHTML = 'Close Project and go back';
		}
	}

	init() {
		const groups = new Map([
			[VideoPlayer, this.container.querySelectorAll('[data-video-player]')],
		]);

		super.createModules(groups);
	}

	destroy() {
		//
	}
}

export default {
	namespace: 'single-project',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Project(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
